import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useVendorStore from "../HomePage/useVendorStore";
import { UPDATE_SELLER_STATUS_ENTITY_TYPE, SELLER_STATUS_APPROVED, SELLER_STATUS_IN_DISPUTE, STATUS_BEGIN, STATUS_DONE, STATUS_FAIL, STATUS_INIT } from "utils/constants/others";
import { strings } from "utils/constants/strings";

export default function useGrnDetailsLogic() {
  const getPoGrnMappings = useVendorStore((state) => state.getPoGrnMappings);
  const getPurchaseOrders = useVendorStore((state) => state.getPurchaseOrders);
  const getPurchaseOrderStatus = useVendorStore(
    (state) => state.getPurchaseOrderStatus
  );
  const purchaseOrders = useVendorStore((state) => state.purchaseOrders);
  let { source, grnId, purchaseOrderId } = useParams();
  const getPoGrnMappingStatus = useVendorStore(
    (state) => state.getPoGrnMappingStatus
  );
  const poGrnList = useVendorStore((state) => state.poGrnList);
  const getGrnPaymentOptions = useVendorStore((state) => state.getGrnPaymentOptions);
  const getGrnPaymentOptionsStatus = useVendorStore((state) => state.getGrnPaymentOptionsStatus);
  const grnPaymentOptions = useVendorStore((state) => state.grnPaymentOptions);
  const [grn, setGrn] = useState("");
  const [generateCn, setGenerateCn] = useState(false);
  const [po, setPo] = useState("");
  const [grnItems, setItems] = useState([]);
  const [openDiscrepancyReasonModal, setOpenDiscrepancyReasonModal] =
    useState(false);
  const [showButtonLoader, setShowButtonLoader] = useState(false);
  const [discrepancyItem, setDiscrepancyItem] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showToast, setShowToast] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const sellerDetails = useVendorStore((state) => state.sellerDetails);
  const updateSellerApprovalStatus = useVendorStore(
    (state) => state.updateSellerApprovalStatus
  );
  const updateSellerStatus = useVendorStore(
    (state) => state.updateSellerStatus
  );
  const updateSellerApprovalErr = useVendorStore(
    (state) => state.updateSellerApprovalErr
  );
  const getSellerDetails = useVendorStore((state) => state.getSellerDetails);
  const [openGrnConfirmedModal, setOpenGrnConfirmedModal] = useState(false);
  const updateEntityStatus = useVendorStore(
    (state) => state.updateEntityStatus
  )
  const [showInvoiceNumberModal, setShowInvoiceNumberModal] = useState(false);

  const [overriddenInvoiceNumber, setOverriddenInvoiceNumber] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [paymentOptionsModal, setPaymentOptionsModal] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  const [fetchingPaymentOptions, setFetchingPaymentOptions] = useState(false);
  const [pendingAction, setPendingAction] = useState(null); // "grn-confirm" or "invoice-generate"
  const [openDisputeRaisedModal, setOpenDisputeRaisedModal] = useState(false);
  // Determine if any item has at least one allowable issue type
  const isDisputeAllowed = Object.values(
    grn?.vendor_grn_dispute_details?.vendor_grn_dispute_allowed?.item_dispute_allowed_map || {}
  ).some((entry) => Array.isArray(entry?.allowed_issue_types) && entry.allowed_issue_types.length > 0);

  // Flatten all submitted dispute issues into a per-item lookup map
  // Shape: { [grn_item_id]: { [issue_type]: claimed_value } }
  const itemDisputeMap = (grn?.vendor_grn_dispute_details?.vendor_grn_disputes ?? [])
    .flatMap((dispute) => dispute.issues ?? [])
    .reduce((acc, issue) => {
      const existing = acc[issue.grn_item_id] ?? {};
      acc[issue.grn_item_id] = { ...existing, [issue.issue_type]: issue.claimed_value };
      return acc;
    }, {});

  const isInDispute = grn?.seller_status === SELLER_STATUS_IN_DISPUTE;

  const grnSummary = grn?.grn_page_data?.summary;
  const grnHeaderTags = grn?.grn_page_data?.header_tags || [];
  const grnDetailsHeaderTag = grnHeaderTags[grnHeaderTags.length - 1];
  const totalGrnWeight = parseFloat(grnItems.reduce((acc, item) => {
    const weight = Number(item?.grn_weight) || 0;
    return acc + weight;
  }, 0).toFixed(2));

  const updateSellerStatusSuccessCallback = () => {
    setGenerateCn(false);
    setOpenGrnConfirmedModal(!openGrnConfirmedModal);
  };

  const [popupText, setPopupText] = useState("");

  const closeConfirmGrnModal = () => {
    setOpenGrnConfirmedModal(false);
    if (source === "all") {
      navigate("/po/list");
    } else {
      navigate("/grn/list");
    }
  };

  const togglePopupModel = () => {
    setShowPopup(!showPopup);
  };

  const HandleSellerStatusUpdate = (id) => {
    const payload = {
      entity_id: id,
      entity_type: UPDATE_SELLER_STATUS_ENTITY_TYPE.PO_GRN_MAPPING,
      seller_status: SELLER_STATUS_APPROVED,
      account_id: window.localStorage.getItem("outlet_id"),
    };

    // Add payment type if payment option was selected
    if (selectedPaymentOption && selectedPaymentOption.payment_type) {
      payload.grn_payment_type = selectedPaymentOption.payment_type;
    }
    if (selectedPaymentOption?.payment_type === "DISCOUNTED") {
      payload.discount_percentage = selectedPaymentOption.discount_percentage;
    }

    poGrnList[0]?.cn_data?.total_cn_amount !== 0
      ? (() => {
        setShowToast(false);
        setGenerateCn(true);
      })()
      : updateSellerStatus(
        payload,
        updateSellerStatusSuccessCallback
      );
  };

  const handleCNCreationEvent = () => {
    updateEntityStatus("createAndGetCnStatus", STATUS_INIT);
    updateSellerStatus(
      {
        entity_id: grn.id,
        entity_type: UPDATE_SELLER_STATUS_ENTITY_TYPE.PO_GRN_MAPPING,
        seller_status: SELLER_STATUS_APPROVED,
        account_id: window.localStorage.getItem("outlet_id"),
      },
      updateSellerStatusSuccessCallback
    );
  };

  const handleCNCreationFailureEvent = () => {
    setErrorMsg(strings.grnErrorConfirmingGrn);
    setGenerateCn(false);
    toggleConfirmationModal();
    setShowToast(true);
  };

  useEffect(() => {
    getPoGrnMappings(
      {
        po_grn_mapping_id: grnId,
        is_po_grn_items_required: true,
        get_cn_data: true,
        fetch_seller_status_meta_data: true,
        fetch_ledger_data: true,
        get_prn_data: true,
        is_payment_details_required: true,
        skip_total_page_count: true,
        fetch_vendor_dispute_data: true,
      },
      true
    );
    getPurchaseOrders(
      {
        is_item_required: true,
        purchase_order_id: purchaseOrderId,
      },
      true
    );
    getSellerDetails({
      phone_number: window.localStorage.getItem("phone_number"),
    });
  }, []);

  // Dispute raised successfully from RaiseDisputePage — show the success modal
  useEffect(() => {
    if (location.state?.disputeSuccess) {
      setOpenDisputeRaisedModal(true);
      window.history.replaceState({}, "");
    }
  }, []);

  useEffect(() => {
    if (getPoGrnMappingStatus === STATUS_DONE && poGrnList) {
      setGrn(poGrnList[0]);
    }
  }, [poGrnList]);

  useEffect(() => {
    setItems(Array.isArray(grn?.po_grn_items) ? grn.po_grn_items : []);
  }, [grn]);

  useEffect(() => {
    if (getPurchaseOrderStatus === STATUS_DONE && purchaseOrders) {
      setPo(purchaseOrders[0]);
    }
  }, [purchaseOrders]);

  useEffect(() => {
    switch (getPoGrnMappingStatus) {
      case STATUS_BEGIN:
        setShowLoader(true);
        break;
      case STATUS_DONE:
        setShowLoader(false);
        break;
    }
  }, [getPoGrnMappingStatus]);

  useEffect(() => {
    if (updateSellerApprovalStatus === STATUS_FAIL) {
      if (updateSellerApprovalErr) {
        setErrorMsg(updateSellerApprovalErr);
      }
      setShowToast(true);
    }
    if (updateSellerApprovalStatus === STATUS_DONE) {
      setShowToast(false);
    }
  }, [updateSellerApprovalStatus]);

  const toggleDiscrepancyModal = (item) => {
    setDiscrepancyItem(item);
    setOpenDiscrepancyReasonModal(!openDiscrepancyReasonModal);
  };

  const proceedWithInvoiceGeneration = () => {
    if ((overriddenInvoiceNumber?.length == 0) && showInvoiceNumberModal) {
      setPopupText(strings.grnEnterInvoiceNumberPopup);
      togglePopupModel();
      return;
    }
    setShowInvoiceNumberModal(false);
    if (source === "all") {
      navigate(`/grn/invoice/all/${purchaseOrderId}/${grnId}?invoice_number=${overriddenInvoiceNumber}`);
    } else {
      navigate(`/grn/invoice/pending/${purchaseOrderId}/${grnId}?invoice_number=${overriddenInvoiceNumber}`);
    }
  };

  const generateInvoiceCTA = () => {
    if (grn?.is_invoice_generation_allowed_for_seller_hub) {
      setSelectedPaymentOption(null);
      setPendingAction(null);
      proceedWithInvoiceGeneration();
      return;
    }

    if (
      grn?.dn_data?.total_dn_amount === 0 &&
      grn?.cn_data?.total_cn_amount === 0
    ) {
      setPendingAction("invoice-generate");
      fetchPaymentOptions(grn.id);
      return;
    }
    setSelectedPaymentOption(null);
    proceedWithInvoiceGeneration();
  };

  const clickInsertInvoiceNumber = () => {
    setShowInvoiceNumberModal(true);
  };
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const toggleConfirmationModal = () => {
    if (
      !openConfirmationModal &&
      grn?.dn_data?.total_dn_amount === 0 &&
      grn?.cn_data?.total_cn_amount === 0
    ) {
      setPendingAction("grn-confirm");
      fetchPaymentOptions(grn.id);
      return;
    }

    setOpenConfirmationModal(!openConfirmationModal);
    if (openConfirmationModal) {
      setSelectedPaymentOption(null);
    }
    setPendingAction(null);
  };

  const handleInvoiceNumberChange = (invoiceNumber) => {
    setOverriddenInvoiceNumber(invoiceNumber);
  }


  const fetchPaymentOptions = (grnId) => {
    setFetchingPaymentOptions(true);
    getGrnPaymentOptions(
      grnId,
      (paymentOptions) => {
        // Check if there are any payment options with discounts
        const hasDiscounts = paymentOptions.some((option) => option.discount > 0);

        if (hasDiscounts) {
          // Show payment options modal only if discounts are available
          setPaymentOptions(paymentOptions);
          setPaymentOptionsModal(true);
        } else {
          // If no discounts, continue with the previous flow based on intent
          if (pendingAction === "invoice-generate") {
            setSelectedPaymentOption(null);
            proceedWithInvoiceGeneration();
          } else {
            setOpenConfirmationModal(true);
          }
        }
        setFetchingPaymentOptions(false);
      },
      (error) => {
        setErrorMsg(error || "Error fetching payment options");
        setShowToast(true);
        setFetchingPaymentOptions(false);
      }
    );
  };

  const handlePaymentOptionSelect = (paymentOption) => {
    setSelectedPaymentOption(paymentOption);
    setPaymentOptionsModal(false);
    const action = pendingAction;
    setPendingAction(null);

    // Based on pending action, either directly confirm GRN or proceed with invoice generation
    if (action === "invoice-generate") {
      proceedWithInvoiceGeneration();
    } else {
      setOpenConfirmationModal(true);
    }
  };

  const closePaymentOptionsModal = () => {
    setPaymentOptionsModal(false);
    setPaymentOptions([]);
    setSelectedPaymentOption(null);
    setPendingAction(null);
  };

  const handleConfirmGrn = () => {
    if (grn?.is_invoice_generation_allowed_for_seller_hub && grn?.is_supplier_bill_number_override_enabled) {
      clickInsertInvoiceNumber();
    } else if (grn?.is_invoice_generation_allowed_for_seller_hub) {
      generateInvoiceCTA();
    } else {
      toggleConfirmationModal();
    }
  };

  // Desktop: the raise-dispute flow opens as a sidebar instead of a separate page.
  const [disputeDrawerOpen, setDisputeDrawerOpen] = useState(false);

  return {
    getPoGrnMappings,
    getPurchaseOrders,
    getPurchaseOrderStatus,
    purchaseOrders,
    source,
    grnId,
    purchaseOrderId,
    getPoGrnMappingStatus,
    poGrnList,
    getGrnPaymentOptions,
    getGrnPaymentOptionsStatus,
    grnPaymentOptions,
    grn,
    setGrn,
    generateCn,
    setGenerateCn,
    po,
    setPo,
    grnItems,
    setItems,
    openDiscrepancyReasonModal,
    setOpenDiscrepancyReasonModal,
    showButtonLoader,
    setShowButtonLoader,
    discrepancyItem,
    setDiscrepancyItem,
    showLoader,
    setShowLoader,
    navigate,
    location,
    showToast,
    setShowToast,
    errorMsg,
    setErrorMsg,
    sellerDetails,
    updateSellerApprovalStatus,
    updateSellerStatus,
    updateSellerApprovalErr,
    getSellerDetails,
    openGrnConfirmedModal,
    setOpenGrnConfirmedModal,
    updateEntityStatus,
    showInvoiceNumberModal,
    setShowInvoiceNumberModal,
    overriddenInvoiceNumber,
    setOverriddenInvoiceNumber,
    showPopup,
    setShowPopup,
    paymentOptionsModal,
    setPaymentOptionsModal,
    paymentOptions,
    setPaymentOptions,
    selectedPaymentOption,
    setSelectedPaymentOption,
    fetchingPaymentOptions,
    setFetchingPaymentOptions,
    pendingAction,
    setPendingAction,
    openDisputeRaisedModal,
    setOpenDisputeRaisedModal,
    isDisputeAllowed,
    itemDisputeMap,
    isInDispute,
    grnSummary,
    grnHeaderTags,
    grnDetailsHeaderTag,
    totalGrnWeight,
    updateSellerStatusSuccessCallback,
    popupText,
    setPopupText,
    closeConfirmGrnModal,
    togglePopupModel,
    HandleSellerStatusUpdate,
    handleCNCreationEvent,
    handleCNCreationFailureEvent,
    toggleDiscrepancyModal,
    proceedWithInvoiceGeneration,
    generateInvoiceCTA,
    clickInsertInvoiceNumber,
    openConfirmationModal,
    setOpenConfirmationModal,
    toggleConfirmationModal,
    handleInvoiceNumberChange,
    fetchPaymentOptions,
    handlePaymentOptionSelect,
    closePaymentOptionsModal,
    handleConfirmGrn,
    disputeDrawerOpen,
    setDisputeDrawerOpen,
  };

}
